import React, { useState } from "react";
import { Card, Form, Input, Button, Typography, Progress, message } from "antd";
import { LockOutlined } from "@ant-design/icons";
import "./style.css";
import AuthLayout from "../../layouts/auth/AuthLayout";

const { Title, Text } = Typography;

const CreatePassword = () => {
  const [strength, setStrength] = useState(0);

  /* PASSWORD STRENGTH CHECK */
  const checkStrength = (password) => {
    let score = 0;

    if (password.length >= 6) score += 25;
    if (/[A-Z]/.test(password)) score += 25;
    if (/[0-9]/.test(password)) score += 25;
    if (/[^A-Za-z0-9]/.test(password)) score += 25;

    setStrength(score);
  };

  const getStatus = () => {
    if (strength < 40) return "exception";
    if (strength < 80) return "active";
    return "success";
  };

  const getLabel = () => {
    if (strength < 40) return "Weak";
    if (strength < 80) return "Medium";
    return "Strong";
  };

  const onFinish = () => {
    message.success("Password Updated Successfully!");
  };

  return (
    <AuthLayout title="Welcome Back 👋">

      <Card className="password-card">
        <Title level={3} className="password-title">
          Create New Password
        </Title>

        <Text className="password-subtitle">
          Create a strong password for your account
        </Text>

        <Form layout="vertical" onFinish={onFinish}>
          {/* NEW PASSWORD */}
          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[{ required: true, message: "Please enter new password" }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Enter new password"
              size="large"
              onChange={(e) => checkStrength(e.target.value)}
            />
          </Form.Item>

          {/* STRENGTH BAR */}
          <div className="strength-box">
            <Progress
              percent={strength}
              status={getStatus()}
              showInfo={false}
            />
            <Text className="strength-label">
              Strength: {getLabel()}
            </Text>
          </div>

          {/* CONFIRM PASSWORD */}
          <Form.Item
            label="Confirm Password"
            name="confirmPassword"
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "Please confirm password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Passwords do not match")
                  );
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Confirm password"
              size="large"
            />
          </Form.Item>

          <Button type="primary" htmlType="submit" block size="large">
            Update Password
          </Button>
        </Form>
      </Card>

    </AuthLayout>
  );
};

export default CreatePassword;
